import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface EnderecoBloqueado {
    id: number
    cep: string
    numero: string
    rua: string
    bairro: string
    cidade: string
}

export interface CadastrarPayload {
    cep: string
    rua: string
    numero: string
    bairro: string
    cidade: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

// Extrai a mensagem do erro priorizando o body da resposta HTTP (ex: 401 com { mensagem: "..." })
function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (isErroBackend(data)) {
        return { codErro: data.codErro, mensagem: data.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterEnderecosBloqueados = async function (
    authorization: string
): Promise<EnderecoBloqueado[] | ErroApi> {
    try {
        const response = await api
            .get<EnderecoBloqueado[] | RespostaErroRaw>("endereco/bloqueados", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as EnderecoBloqueado[]
    } catch (error) {
        RegistrarLogErro(error, "ObterEnderecosBloqueados", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const cadastrarEnderecoBloqueado = async function (
    authorization: string,
    payload: CadastrarPayload
): Promise<EnderecoBloqueado[] | ErroApi> {
    try {
        const response = await api
            .post<EnderecoBloqueado[] | RespostaErroRaw>("endereco/bloqueados", payload, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as EnderecoBloqueado[]
    } catch (error) {
        RegistrarLogErro(error, "CadastrarEnderecoBloqueado", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const excluirEnderecoBloqueado = async function (
    authorization: string,
    id: number
): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<RespostaErroRaw | null>(`endereco/bloqueados/${id}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (response.data && isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "ExcluirEnderecoBloqueado", String(id))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
